import React from "react";
import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { MONTH_NAMES } from "@/lib/format";

export default function MonthSelector({ year, month, onChange }) {
  const prev = () => {
    let y = year, m = month - 1;
    if (m < 1) { m = 12; y -= 1; }
    onChange(y, m);
  };
  const next = () => {
    let y = year, m = month + 1;
    if (m > 12) { m = 1; y += 1; }
    onChange(y, m);
  };
  return (
    <div className="flex items-center gap-2" data-testid="month-selector">
      <Button variant="secondary" size="icon" onClick={prev} data-testid="month-prev-btn">
        <ChevronLeft className="h-5 w-5" />
      </Button>
      <div className="min-w-[170px] rounded-lg border border-border bg-card px-4 py-2 text-center font-display text-base font-bold" data-testid="month-label">
        {MONTH_NAMES[month]} {year}
      </div>
      <Button variant="secondary" size="icon" onClick={next} data-testid="month-next-btn">
        <ChevronRight className="h-5 w-5" />
      </Button>
    </div>
  );
}
